import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=7215fc11&scoped=true&"
import script from "./TypeList.vue?vue&type=script&lang=js&"
export * from "./TypeList.vue?vue&type=script&lang=js&"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=7215fc11&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215fc11",
  null
  
)

export default component.exports